module.exports = __webpack_public_path__ + "img/test.5066bc2e.png";